import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectDate } from '../../redux/actions';
import { HotelSearchCard, HotelSearchCardGhost } from '../../components';
import { Eye, defaultCity, startWithUpperCase } from '../../utils';

import {
  SearchPageNothingFound,
  SearchPageContainer,
  CurrentVisitors,
  SearchList,
  SearchItem,
} from './styles';

const mapStateToProps = state => ({
  product: state.userPreferences.product,
  city: state.userPreferences.city,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleDateSelection: selectDate,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class SearchPageResults extends Component {
  static propTypes = {
    searchResults: PropTypes.instanceOf(Array),
    showsLosAngeles: PropTypes.bool,
    amountOfPeopleOnPage: PropTypes.number,
    product: PropTypes.string,
    city: PropTypes.instanceOf(Object),
    hasMore: PropTypes.bool,
    handleDateSelection: PropTypes.func,
    handlePageScrollLoading: PropTypes.func,
    loading: PropTypes.bool,
    marketName: PropTypes.string,
    badgesEnabled: PropTypes.bool
  };

  componentDidMount() {
    const searchDate = localStorage.getItem('searchDate');
    const { handleDateSelection } = this.props;

    if (searchDate) {
      handleDateSelection(searchDate)
    }
  }

  renderListHeading = () => {
    const { city, showsLosAngeles, amountOfPeopleOnPage, marketName } = this.props;

    if (showsLosAngeles) {
      return (
        <Fragment>
          We were unable to find results for<b>{city.label.split(',').join(', ')}</b>, showing for<b>{defaultCity.label.split(',').join(', ')}</b>
        </Fragment>
      );
    }

    return (
      <Fragment>
        <Eye />
        {amountOfPeopleOnPage > 1 ? (
          <Fragment>
            {amountOfPeopleOnPage} people are looking for passes in {startWithUpperCase(marketName)}
          </Fragment>
        ) : (
          <Fragment>
            Someone else is looking for passes in {startWithUpperCase(marketName)}
          </Fragment>
        )}
      </Fragment>
    );
  };

  render() {
    const { renderListHeading } = this;
    const {
      searchResults,
      hasMore,
      handlePageScrollLoading,
      loading,
      badgesEnabled,
    } = this.props;
    return (
      <SearchPageContainer>
        {searchResults.length > 0 ? (
          <Fragment>
            <CurrentVisitors>{renderListHeading()}</CurrentVisitors>
            <section style={{ width: '100%' }}>
              {loading ? (
                <SearchList>
                  {Array(10)
                    .fill(0)
                    .map((card, index) => (
                      <SearchItem key={index}>
                        <HotelSearchCardGhost />
                      </SearchItem>
                    ))}
                </SearchList>
              ) : (
                <InfiniteScroll
                  pageStart={0}
                  hasMore={hasMore}
                  initialLoad={false}
                  loadMore={handlePageScrollLoading}
                  loader={<SearchItem key={-1}><HotelSearchCardGhost /></SearchItem>}
                >
                  <SearchList>
                    {
                      searchResults.map((result, index) => (
                        <SearchItem key={`${result.id}-${result.productType}-${index}`}>
                          <HotelSearchCard {...result} badgesEnabled={badgesEnabled} />
                        </SearchItem>
                      ))
                    }
                  </SearchList>
                </InfiniteScroll>
              )}
            </section>
          </Fragment>
        ) : (
          <SearchPageNothingFound>Nothing found</SearchPageNothingFound>
        )}
      </SearchPageContainer>
    );
  }
}

export default SearchPageResults;
